import { Component, Input, OnInit } from "@angular/core"
import { ResourceService } from "../../../services/resource.service"
import { WindowSizeService } from "../../../services/window-size.service"
import { ModalService } from "../../../shared-components/modal/modal.service"
import { InformationModalComponent } from "../../../shared-components/modals/information-modal/information-modal.component"
import { catchError } from "rxjs/operators"
import { throwError } from "rxjs"
import { AddOnViewService } from "../../../services/add-on-view.service"
import { Resource } from "../../../models/resource/resource"
import { ModalRef } from "../../../shared-components/modal/modal-ref"
import { routeAnimations, routeTransition } from "../../../utils/animations"

@Component({
    selector: "app-lesson-plan-resource",
    templateUrl: "./lesson-plan-resource.component.html",
    styleUrls: ["./lesson-plan-resource.component.scss"],
    host: { "[@routeTransition]": "true", "[@routeAnimations]": "false", style: "display: block;" },
    animations: [routeTransition, routeAnimations],
    standalone: false,
})
export class LessonPlanResourceComponent implements OnInit {
    @Input() resource: Resource
    readonly gtmPrefix: string = "gtm-lesson-plan-resource"
    isAddonView: boolean

    constructor(
        public windowSize: WindowSizeService,
        public resourceService: ResourceService,
        public window: Window,
        private addOnViewService: AddOnViewService,
        private modalService: ModalService
    ) {}

    ngOnInit() {
        this.isAddonView = this.addOnViewService.isAddonView
    }

    public prepareAndDownloadDoc(event) {
        event.preventDefault()
        const downloadBtn: HTMLAnchorElement = document.getElementById(
            "export-word"
        ) as HTMLAnchorElement
        downloadBtn.classList.add("disabled")
        this.resourceService.getLessonPlanExportUrl(this.resource).subscribe((downloadUrl: any) => {
            if (downloadUrl.downloadUrl) {
                downloadBtn.classList.remove("disabled")
                const element: HTMLAnchorElement = document.getElementById(
                    "download-word"
                ) as HTMLAnchorElement
                element.href = downloadUrl.downloadUrl
                element.click()
            } else {
                downloadBtn.classList.remove("disabled")
                this.modalService.open(InformationModalComponent, {
                    data: {
                        message:
                            "Your export is being prepared. Please try again in a few minutes.",
                        shouldDisplayHeaderCloseButton: true,
                        shouldDisplayFooterCloseButton: true,
                    },
                })
            }
        })
    }

    public printLessonPlan() {
        const iframeObj: HTMLIFrameElement = document.getElementById(
            "lesson_plan_html_content"
        ) as HTMLIFrameElement
        const iframedoc: Document = iframeObj.contentDocument || iframeObj.contentWindow.document
        this.resourceService
            .getLessonPlanContent(this.resource.resourceCode)
            .pipe(
                catchError((error) => {
                    const informationModal: ModalRef = this.modalService.open(
                        InformationModalComponent,
                        {
                            data: {
                                message:
                                    "Your print data is being prepared. Please try again in a few minutes.",
                                shouldDisplayHeaderCloseButton: true,
                                shouldDisplayFooterCloseButton: true,
                            },
                        }
                    )
                    return throwError(error)
                })
            )
            .subscribe((data: any) => {
                iframedoc.body.innerHTML = data.lesson_plan_html_content
                setTimeout(() => {
                    iframeObj.contentWindow.focus()
                    iframeObj.contentWindow.print()
                }, 250)
            })
    }
}
